import Vue from 'vue';
import store from './store';
import '@mdi/font/css/materialdesignicons.css';
import VueI18n from 'vue-i18n'
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import i18n from "./plugins/i18n";

//global methods
import g from './global/globalMethods'


Vue.config.productionTip = false;

Vue.prototype.$mainColor = '#010108';
Vue.prototype.g = g;
new Vue({
  vuetify,
  router,
  store,
  i18n,
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  render: (h) => h(App),
}).$mount('#app');
